module.exports = __webpack_public_path__ + "static/media/emilie-lose.cdcb27c2.png";